(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$stickyStateProvider','$urlRouterProvider'];

    function stateConfig($stateProvider, $stickyStateProvider, $urlRouterProvider) {
        $stateProvider
            .state('controller', {
                parent: 'app',
                url: '/controller',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI'],
                    pageTitle: 'ccsTrApp.controller.home.title',
                    title: 'Controller Payment Management'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/controller/controller.html',
                        controller: 'ControllerController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('controller');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('controller.all', {
                parent: 'app',
                url: '/controller/all',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI'],
                    pageTitle: 'ccsTrApp.controller.home.title',
                    title: 'Controller Payment Management'
                },
                views: {
                    'controller-all@': {
                        templateUrl: 'app/entities/controller/controller.html',
                        controller: 'ControllerController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('controller');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('controller.detail', {
                parent: 'app',
                url: '/controller/{id}/detail',
                sticky: false,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI'],
                    pageTitle: 'ccsTrApp.controller.detail.title',
                    title: 'Controller Payment Detail'
                },
                views: {
                    'controller-detail@': {
                        templateUrl: 'app/entities/controller/controller-detail.html',
                        controller: 'ControllerDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('controller');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams','$state','Controller', function($stateParams, $state, Controller) {
                        var paramId = $stateParams.id > 0 ? $stateParams.id : $state.params.id;
                        return Controller.get({id: paramId}).$promise;
                    }],
                    previousState: ['$state', function($state) {
                        return {
                            name: $state.current.name || 'controller',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        }
                    }]
                }
            })
            .state('controller.new', {
                parent: 'app',
                url: '/controller/new',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI']
                },
                onEnter: ['$stateParams','$state','$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/controller/controller-dialog.html',
                        controller: 'ControllerDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function() {
                                return {
                                    id: null,
                                    createdOn: new Date(),
                                    createdBy: 'admin',
                                    modifiedOn: new Date(),
                                    modifiedBy: 'admin',
                                    controller: null,
                                    amount: 0,
                                    balance: 0,
                                    currency: 'USD',
                                    amountDisplay: null,
                                    shipment: null,
                                    invoice: null
                                };
                            },
                            translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('controller');
                                $translatePartialLoader.addPart('currencyType');
                                $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(function() {
                        $state.go('controller.all', null, {reload:'controller.all'});
                    }, function() {
                        $state.go('controller.all');
                    });
                }]
            })
            .state('controller.edit', {
                parent: 'app',
                url: '/controller/{id}/edit',
                sticky: false,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI']
                },
                onEnter: ['$stateParams','$state','$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/controller/controller-dialog.html',
                        controller: 'ControllerDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Controller', function(Controller) {
                                return Controller.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('controller.all', null, {reload:'controller.all'});
                    }, function() {
                        $state.go('controller.all');
                    });
                }]
            })
            .state('controller.delete', {
                parent: 'app',
                url: '/controller/{id}/{delete}',
                sticky: false,
                date: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI']
                },
                onEnter: ['$stateParams','$state','$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/controller/controller-delete-dialog.html',
                        controller: 'ControllerDeleteDialogController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Controller', function(Controller) {
                                return Controller.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('controller.all', null, {reload: 'controller.all'});
                    }, function() {
                        $state.go('controller.all');
                    });
                }]
            })
        $stickyStateProvider.enableDebug(true);
    }
})();
